import React from 'react';
import CalendarConfig from '../../../../consts/CalendarConfig';
import { getScale } from '../../../../pages/appointment/modules/scales';
import { summarizeValue, valueColor } from '../../../../pages/appointment/modules/scales/scaleValues';
import paper from '../ReportPaper.module.css';
import styles from './textBodies.module.css';

/**
 * Miolo do PDF de uma escala clínica: o resultado em destaque e a evolução
 * por data logo abaixo (o registro em destaque recebe a etiqueta).
 *
 * `scaleKey`: chave do catálogo; `current`: registro em destaque;
 * `records`: registros da escala, do mais recente ao mais antigo.
 */
export const ScaleReportBody = ({ scaleKey, current, records }) => {
  const scale = getScale(scaleKey);
  if (!scale || !current) return null;
  const list = Array.isArray(records) ? records : [];

  return (
    <>
      <div className={styles.record}>
        <div className={styles.recordHead}>
          <span className={styles.recordDate}>{CalendarConfig.GetDDMMAAAA(current.assessedAt)}</span>
          <span className={styles.tag}>Resultado</span>
        </div>
        <div className={styles.text}>{summarizeValue(scale, current.value)}</div>
      </div>

      {list.length > 1 && (
        <table className={paper.table}>
          <thead>
            <tr>
              <th>Data</th>
              <th>Resultado</th>
            </tr>
          </thead>
          <tbody>
            {list.map((record) => {
              const color = valueColor(scale, record.value);
              return (
                <tr key={record.id}>
                  <td>{CalendarConfig.GetDDMMAAAA(record.assessedAt)}</td>
                  <td>
                    {color && <span className={paper.dot} style={{ background: color }} />}
                    {summarizeValue(scale, record.value)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ScaleReportBody;
